module.exports = __webpack_public_path__ + "static/media/logoHeader.2ee75b2d.svg";